import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { SkeletonRectComponent } from '../rect/skeleton-rect.component';

@Component({
    selector: 'skeleton-product',
    templateUrl: './skeleton-product.component.html',
    styleUrl: './skeleton-product.component.scss',
    standalone: true,
    imports: [SkeletonRectComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkeletonProductComponent extends UiComponent {
    ratio = input<string>('ratio-3-4');
    banner = input<boolean>(false);
}
